/**
 * 根据 user-agent 判断是否为 Windows 操作系统
 * 仅适用于浏览器环境
 * @returns {boolean} 如果是 Windows 返回 true，否则返回 false
 */
export const isWin = () => {
  const userAgent =
    typeof window !== "undefined" && window.navigator
      ? window.navigator.userAgent
      : "";

  // 使用正则表达式检查是否包含 Windows 标识
  return /windows nt/i.test(userAgent);
};
